var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SelectWidget as _SelectWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var SelectWidget = (function (_super) {
    __extends(SelectWidget, _super);
    function SelectWidget() {
        var _this = _super.call(this) || this;
        _this.blank = { value: null, label: 'Please select' };
        return _this;
    }
    SelectWidget.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
        switch (this.schema.type) {
            case 'string':
                this.blank.value = '';
                break;
            case 'number':
                this.blank.value = null;
                break;
            case 'integer':
                this.blank.value = null;
                break;
            case 'boolean':
                this.blank.value = null;
                break;
        }
        if (this.schema.options && typeof this.schema.options.enumBlankTitle !== 'undefined') {
            this.blank.label = this.schema.options.enumBlankTitle;
        }
    };
    Object.defineProperty(SelectWidget.prototype, "hasBlank", {
        get: function () {
            return typeof this.widget.hasBlank !== 'undefined' ? this.widget.hasBlank : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectWidget.prototype, "widget", {
        get: function () {
            var widget = this.schema.widget;
            return typeof widget === 'string' ? ({ id: widget }) : widget;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectWidget.prototype, "options", {
        get: function () {
            var values = this.schema.enum || null;
            var labels = (this.schema.options && this.schema.options.enum_titles) || null;
            if (this.schema.type === 'boolean') {
                values = values || [true, false];
                labels = labels || ['Yes', 'No'];
            }
            // Generate numerical values between max and min
            // Assumes values are integers
            if ((this.schema.type === 'number' || this.schema.type === 'integer') && values === null &&
                (typeof this.schema.minimum !== 'undefined' || typeof this.schema.exclusiveMinimum !== 'undefined') &&
                (typeof this.schema.maximum !== 'undefined' || typeof this.schema.exclusiveMaximum !== 'undefined')) {
                var min = typeof this.schema.minimum !== 'undefined' ? this.schema.minimum : this.schema.exclusiveMinimum + 1;
                var max = typeof this.schema.maximum !== 'undefined' ? this.schema.maximum : this.schema.exclusiveMaximum - 1;
                values = Array(max - min + 1).fill(min).map(function (v, i) { return v + i; });
                labels = values.slice().map(function (v) { return v.toString(); });
            }
            values = values || [];
            labels = labels || [];
            return (this.hasBlank ? [this.blank] : []).concat(values.map(function (value, index) { return ({ value: value, label: labels[index] }); }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectWidget.prototype, "selectOptions", {
        get: function () {
            var optgroup;
            return this.options.reduce(function (optionList, option, optionIndex, allOptions) {
                var groupPrefix = 'GROUP_';
                var optVal = option.value === null ? '' : option.value.toString();
                if (optgroup && (!optVal.startsWith(optgroup.valuePrefix) || optionIndex === allOptions.length - 1)) {
                    // Finished group
                    optionList.push(optgroup);
                    optgroup = null;
                }
                if (!optgroup && optVal.startsWith(groupPrefix)) {
                    optgroup = {
                        label: option.label,
                        valuePrefix: optVal.substring(groupPrefix.length),
                        options: [],
                    };
                }
                else {
                    if (optgroup) {
                        optgroup.options.push(option);
                    }
                    else {
                        optionList.push(option);
                    }
                }
                return optionList;
            }, []);
        },
        enumerable: true,
        configurable: true
    });
    SelectWidget.prototype.optionIdentity = function (index, option) {
        return option.value;
    };
    Object.defineProperty(SelectWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    return SelectWidget;
}(_SelectWidget));
export { SelectWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/select.widget.ts.pre-build-optimizer.js